<template>
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="经销商">
        <exadelar></exadelar>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="门店">
        <exastore></exastore>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  import {  } from "@ant-design/icons-vue";
  import { ref,inject } from "vue";
  import exadelar from './components/exaDelar';
  import exastore from './components/exaStore';
  export default {
    components: { exastore, exadelar },
    setup() {
      const activeKey = ref(1);
      const $router = inject("$router");
      return {
        activeKey
      };
    },
  };
</script>